module.exports = __webpack_public_path__ + "static/media/coin1.5540358f.png";